import React from "react";
import styled from "styled-components";
import { IPageSectionResponse } from "models/response/page-section-response";
import { SectionTitle } from "../custom-page.styles";

const VideoContainer = styled.div`
  margin-bottom: 30px;
`;

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 56.25%; /* 16:9 aspect ratio */
  height: 0;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

interface VideoEmbedSectionProps {
    section: IPageSectionResponse;
}

// Função para extrair e formatar URL do vídeo
const getEmbedUrl = (url: string): string | null => {
    if (!url) return null;

    // YouTube
    const youtubeRegex = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/;
    const youtubeMatch = url.match(youtubeRegex);
    if (youtubeMatch && youtubeMatch[1]) {
        return `https://www.youtube.com/embed/${youtubeMatch[1]}`;
    }

    // Vimeo
    const vimeoRegex = /vimeo\.com\/(?:.*\/)?(\d+)/;
    const vimeoMatch = url.match(vimeoRegex);
    if (vimeoMatch && vimeoMatch[1]) {
        return `https://player.vimeo.com/video/${vimeoMatch[1]}`;
    }

    // Se já é uma URL de embed, retorna ela mesma
    if (url.includes('youtube.com/embed') || url.includes('player.vimeo.com')) {
        return url;
    }

    return null;
};

export const VideoEmbedSection: React.FC<VideoEmbedSectionProps> = ({ section }) => {
    const embedUrl = getEmbedUrl(section.url || '');

    if (!embedUrl) {
        return null;
    }

    return (
        <VideoContainer>
            {section.title && <SectionTitle>{section.title}</SectionTitle>}
            <VideoWrapper>
                <iframe
                    src={embedUrl}
                    title={section.title || 'Vídeo'}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                />
            </VideoWrapper>
        </VideoContainer>
    );
};
